import OdmsLayer from './OdmsLayer'
import { MiscUtil } from '../../miscUtil'
import { isString } from 'util'

/**
 * 获取odms options
 * @param {String} url
 * @param {String} layerId
 */
export async function getOdmsOptions(url, layerId) {
    const _url = url.replace(new RegExp(`(/)?${layerId}(/)?`), '')
    return MiscUtil.fetchWithPorxy(
        `${_url}/data/${layerId}/-180/-90/180/90?f=json`
    )
}

/**
 * 新建odmslayer
 * @param {String|Object} echartOption
 * @param {*} opt_options
 */
export function newOdmsLayer(echartOption, opt_options) {
    if (isString(echartOption)) {
        echartOption = JSON.parse(echartOption)
    }
    return new OdmsLayer(echartOption, opt_options)
}
